import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="images--slide-show"
export default class extends Controller {
  static targets = ["slide"];
  static values = { selection: String };

  updateSelection(event) {
    this.selectionValue = event.target.dataset.identifier;
    console.log(this.highlightClasses);
  }

  selectionValueChanged() {
    this.slideTargets.forEach((slide) => {
      if (slide.dataset.identifier === this.selectionValue) {
        slide.classList.add(...this.highlightClasses);
      } else {
        slide.classList.remove(...this.highlightClasses);
      }
    });
  }

  get highlightClasses() {
    return [
      "rounded-lg",
      "scale-90",
      "ring-3",
      "ring-offset-3",
      "ring-main-500/50",
    ];
  }
}
